import { Component } from "@angular/core";
import { ProductService } from "src/app/core/services/product.service";

@Component({
  selector: "app-coupon",
  templateUrl: "./coupon.component.html",
  styleUrls: ["./coupon.component.scss"],
})
export class CouponComponent {
  breadCrumbItems = [
    { label: "Product Management" },
    { label: "Coupon", active: true },
  ];
  couponList: any = [];
  currentCouponType: string = "general";

  setBreadCrumb(title: string) {
    this.breadCrumbItems[1].label = title;
  }
}
